import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import CurrencyInput from '../../components/form/CurrencyInput/CurrencyInput'
import { isAnyBlank } from '../../utils/string'
import AlumnoSelector from '../../components/form/AlumnoSelector/AlumnoSelector'
import css from './ModalNuevoPagoAlumno.module.css'

const ModalNuevoPagoAlumno = ({ open, onClose, onSubmit }) => {
  const [alumno, setAlumno] = useState('')
  const [concepto, setConcepto] = useState('')
  const [importe, setImporte] = useState('')

  const isSubmitDisabled = isAnyBlank(alumno, concepto, importe)

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle>Nuevo pago</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Vas a añadir un nuevo pago para este alumno.
        </DialogContentText>
        <AlumnoSelector
          className={css.input}
          name='alumno'
          label='Alumno'
          value={alumno}
          onChange={(_, value) => setAlumno(value)}
        />
        <TextField
          className={css.input}
          fullWidth
          name='concepto'
          label='Concepto del pago'
          variant='standard'
          value={concepto}
          onChange={e => setConcepto(e.target.value)}
        />
        <CurrencyInput
          className={css.input}
          name='importe'
          label='Importe a pagar'
          value={importe}
          onChange={value => setImporte(value)}
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          color='primary'
          disabled={isSubmitDisabled}
          onClick={() => onSubmit({ alumno: alumno.id, concepto, importe })}
        >
          Crear pago
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoPagoAlumno
